/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserInvitationStatus {
    NOT_SET = 'NotSet',
    ACCEPTED = 'Accepted',
    REJECTED = 'Rejected',
}
